/** @jsx jsx */

import { css, jsx } from '@emotion/core';

type Props = {
  isOrdered?: boolean;
  children: React.ReactNode;
};

const Styles = {
  root: (isOrdered: boolean) => css`
    padding-left: 1em;
    margin-bottom: 0.5em;
    list-style-type: ${isOrdered ? 'decimal' : 'disc'};
    &:last-child {
      margin-bottom: 0;
    }
  `,
};

const MessageList = ({ children, isOrdered = false }: Props) => {
  const Tag = isOrdered ? 'ol' : 'ul';
  return <Tag css={Styles.root(isOrdered)}>{children}</Tag>;
};

MessageList.defaultProps = {
  isOrdered: false,
};

export default MessageList;
